import React from 'react'

export default props => (
    <div>Accès non autorisé, contactez votre administrateur.</div>
)